export const IMG_BASE_URL = "https://flymya.com";
export const DATALAYER_URL = "https://booking.flymya.com";
export const REACT_APP_GORGIAS_TICKET = `${process.env.REACT_APP_BE_SERVER}/api/gorgias/post/tickets/`;
export const REACT_APP_REDIRECT_URL = window.location.origin;

export const CALL_CENTER_PHONENO = "+959880441011";
export const CALL_CENTER_PHONENO_SPACE = "+95 9 880 441 011";
export const CC_PHONENO_LINK = "tel:+959880441011";

export const CORPORATE_HOTLINENO = "+959880441313";
export const CORPORATE_HOTLINENO_LINK = "tel:+959880441313";

export const BLOCK_EMAIL = "airticket770@gmail.com";
export const BLOCK_PHONE = "698868431";

export const MM_LOCALE = "my-MM";
export const EN_LOCALE = "en-US";
export const MY_MM = "my-mm";

export const MY_LANGUAGE_ID = 4;
export const EN_LANGUAGE_ID = 1;

export const BUS_TIMEOUT = 9;

export const TWO_MINS_TIMEOUT = 120000;
export const TEN_MINS_TIMEOUT = 600000;

export const TOP_CITY_BUS = [
  "Yangon",
  "Mandalay",
  "Naypyitaw (Myoma)",
  "Naypyitaw (Bawga)",
  "Naypyitaw (Thapyaygone)",
  "Naypyitaw(Toll Gate)",
];

export const TOKEN_TYPE = "token_type";
export const AUTH_TOKEN = "access_token";
export const LOGIN_USER_ID = "userId";
export const LOGIN_USER_DATA = "userData";
export const IDENTIFIER = "identifier";
export const EXPIRES_IN = "expires_in";
export const LOGIN_PEOPLE_COMPANY = "login_company";
export const LOGIN_PEOPLE_CLASS_TYPE = "login_company_class_type";
export const LOGIN_USER_PEOPLE = "login_people";
export const IS_B2B = "is_b2b";
export const IS_CALL_CENTER = "is_call_center";
export const IS_CUSTOMER = "is_customer";
export const IS_EMPLOYEE = "is_employee";
const IS_CUSTOMER_VAL =
  localStorage.getItem("is_customer") &&
  localStorage.getItem("is_customer") === "yes"
    ? true
    : false;
export const LOGIN_PEOPLE_DETAIL = "login_people_detail";
export const B2B_ClASS_TYPE = "b2bClassType";
export const LOGIN_NAME = "login_name";
export const LOGIN_EMAIL = "login_email";
export const LOGIN_PHONE_PREFIX = "login_phone_prefix";
export const LOGIN_PHONE = "login_phone";
export const LOGIN_SOCIAL = "login_social";
export const LOGIN_TYPE = "login_type";
export const SOCIAL_TOKEN = "social_token";
export const ADDRESSBOOK_ID = "addressbook_id";
export const ARRANGER_PEOPLE_ID = "arranger_people_id";
export const PASSENGER_COUNT = "passenger_count";
export const LOGIN_VIA_KBZPAY = "kbz_user_data";
export const ARR_PARTNERSHIP_OBJ = "arr_partnership_obj";

export const B2BCLASSTYPE_B_ID = "1";
export const B2BCLASSTYPE_N_ID = "2";
export const B2C_ID = "3";
export const B2BCLASSTYPE_C_ID = "4";
export const GUEST_ID = "5";
export const B2BCLASSTYPE_E_ID = "6";
export const B2BCLASSTYPE_S_ID = "7";
export const SUPPLIER_ID = "8";
export const STUDENT_ID = "9";
export const AFFILIATED_EMPLOYEE_ID = "10";
export const AFFILIATED_MEMBER_ID = "11";

export const B2BCLASSTYPE_B_ID_NAME = "Class B";
export const B2BCLASSTYPE_N_ID_NAME = "Class N";
export const B2C_ID_NAME = "B2C";
export const B2BCLASSTYPE_C_ID_NAME = "Class C";
export const FLYMYA_WEBSITE_FARE_LABEL = "Flymya Website Fare";
export const FLYMYA_CORPORATE_FARE_LABEL = "Flymya Corporate Fare";
export const GUEST_ID_NAME = "Guest";
export const B2BCLASSTYPE_E_NAME = "Class E";
export const B2BCLASSTYPE_S_NAME = "Class S";
export const SUPPLIER_NAME = "Supplier";
export const STUDENT_NAME = "Student";
export const AFFILIATED_EMPLOYEE_NAME = "Affiliated Employee";
export const AFFILIATED_MEMBER_NAME = "Affiliated Member";

export const PASSENGER_MAX_COUNT = 5;

export const DOMESTIC_PRODUCT_TYPE_ID = 1;
export const DOMESTIC_ROUNDTRIP_PRODUCT_TYPE_ID = 12;
export const HOTEL_PRODUCT_TYPE_ID = 4;
export const VISA_PRODUCT_TYPE_ID = 20;
export const AIRPORT_VIP_PRODUCT_TYPE_ID = 23;
export const INSURANCE_PRODUCT_TYPE_ID = 19;
export const BALLOON_PRODUCT_TYPE_ID = 5;
export const CARRENTAL_PRODUCT_TYPE_ID = 6;
export const DOMESTIC_MULTI_PRODUCT_TYPE_ID = 17;
export const INTERNATIONAL_MULTI_PRODUCT_TYPE_ID = 18;

export const SALES_WAVEPAY_APP = 19;
export const SALES_ONEPAY_APP = 18;
export const SALES_KBZPAY_APP = 17;
export const SALES_MPITESAN_APP = 22;
export const SALES_AYAPAY_APP = 44;
export const SALES_MOMONEY_APP = 49;
export const SALES_UAB_APP = 50;
export const SALES_WEBSITE = 15;
export const SALES_DESKTOP = 23;
export const SALES_MOBILE = 24;
export const SALES_TABLET = 25;
export const SALES_B2B_PORTAL = 28;
export const SALES_B2B_OFFLINE_PORTAL = 39;
export const SALES_NINJA_VAN_INWEB = 52;
export const SALES_UAB_INWEB = 53;
export const SALES_ABC_STORE_INWEB = 54;
export const SALES_KBZ_INWEB = 55;
export const SALES_VIBER_INWEB = 56;
export const SALES_CITY_REWARD_INWEB = 57;
export const SALES_GRAB_INWEB = 63;
export const SALES_ATOM_INWEB = 64;
export const SALES_FOODPANDA_INWEB = 65;
export const SALES_B2C_OFFLINE_PROMO = 60;
export const SALES_MPTCLUB_INWEB = 67;
export const SALES_CBPAY_APP = 70; //live will be 70 //UAT will 76
export const SALES_DOCDOC_DASH_IN_WEB = 71; //live will be 71 //UAT will 77
export const SALES_WAVE_CENTER_IN_WEB = 72; //live will be 72 //UAT will 78
export const SALES_SFU_IN_WEB = 73; //live will be 73 //UAT will 79
export const SALES_TRUEMONEY_IN_WEB = 77; // 77 on honey/live // 81 on coffee
export const SALES_TOURISM_MALAYSIA_IN_WEB = 78; // 78 on live // 82 on coffee

export const B2B_OFFLINE_PORTAL = 40;
export const B2B_CORPORATE_ONLINE = 41;
export const B2B_CORPORATE_OFFLINE = 42;
export const SALES_CITIZENPAY_APP = 43;

export const SOURCE_TYPE_CAMPAIGN = 1;
export const SOURCE_TYPE_REFERRAL = 2;
export const SOURCE_TYPE_PROMO = 3;
export const SOURCE_TYPE_DEVICE = 4;
export const SOURCE_TYPE_PROMOTION = 11;
export const SOURCE_TYPE_WALLET_ACTIVITY = 10;
export const SOURCE_TYPE_CLIENT = 12;
export const SOURCE_TYPE_AUTO_DISCOUNT = 6;
export const SOURCE_TYPE_COUPON = 13;

export const FLYMYA_FAMILY_MMK = "1359_companyAccount";
export const FLYMYA_FAMILY_USD = "1360_companyAccount";
export const FLYMYA_COMPANY_EXPENSE_MMK = "1532_companyAccount";
export const FLYMYA_COMPANY_EXPENSE_USD = "1533_companyAccount";

export const ONLINE_PAYMENTS = [
  "KBZ Pay",
  "Wave Money",
  "Stripe",
  "MPU (2C2P)",
  "Paypal",
  "M-Pitesan",
  "123 OTC (2C2P)",
  "MoMoney",
];

export const PRODUCT_GROUPS = [
  { name: "flight", id: 1 },
  { name: "bus", id: 2 },
  { name: "balloon", id: 3 },
  { name: "car", id: 4 },
  { name: "services", id: 5 },
  { name: "tour", id: 6 },
  { name: "hotel", id: 7 },
  { name: "offline_hotel", id: 8 },
  { name: "online_hotel", id: 9 },
  { name: "long_stay_hotel", id: 10 },
];

export const getIataCodes = (city) => {
  const airportMapping = {
    "New York, USA": ["JFK", "LGA", "EWR"],
    "Los Angeles, USA": ["LAX", "BUR", "LGB", "ONT", "SNA"],
    "Chicago, USA": ["ORD", "MDW"],
    "San Francisco, USA": ["SFO", "OAK", "SJC"],
    "Washington, D.C., USA": ["IAD", "DCA", "BWI"],
    "London, UK": ["LHR", "LGW", "LCY", "LTN", "STN", "SEN"],
    "Berlin, Germany": ["BER"],
    "Frankfurt, Germany": ["FRA", "HHN"],
    "Paris, France": ["CDG", "ORY", "BVA"],
    "Tokyo, Japan": ["NRT", "HND"],
    "Osaka, Japan": ["KIX", "ITM"],
    "Toronto, Canada": ["YYZ", "YTZ"],
    "Shanghai, China": ["PVG", "SHA"],
    "Beijing, China": ["PEK", "PKX"],
    "Sydney, Australia": ["SYD"], // Future airport not included until operational
    "Bangkok, Thailand": ["BKK", "DMK"],
    "Moscow, Russia": ["SVO", "DME", "VKO", "ZIA"],
  };
  // return airportMapping[city] || [city.toUpperCase()];
  return airportMapping[city] || [];
};

export const MYANMAR_ID = 153;
export const YANGON_REGION = 4;
export const YANGON_CITY = 28;
export const SINGAPORE_ID = 200;

export const MOBILE_REDIRECT = "OFF"; // Value 'ON' || 'OFF' to show or hide the mobile redirect area (HomePromote Component)

export const TRAVEL_VISA_SERVICE = "visa-service";
export const TRAVEL_VIP_SERVICE = "vip-service";
export const TRAVEL_INSURANCE_SERVICE = "insurance-service";
export const HOTEL_LONG_STAY = "hotel-long-stay";

export const BALLOON_MAX_DATE = "2023-04-30";

export const CACHE_KEY = "airportList";
export const CACHE_EXPIRY_KEY = "airportListExpiry";
export const CACHE_DURATION = 60 * 60 * 1000;

export const FLIGHT_RESULT_CACHE_KEY = "flightResultCache";
export const FLIGHT_FARE_SELECTION_CACHE_KEY = "flightFareSelectionCache";
export const FLIGHT_RT_SELECTION_CACHE_KEY = "flightRoundTripSelectionCache";
export const FLIGHT_FILTER_CACHE_KEY = "flightFilterCache";
export const FLIGHT_QUERY_ID_CACHE_KEY = "flightQueryIdByFare";
export const FLIGHT_SORT_VALUE_KEY = "flightSortByValue";
// Set by the customer details page on its way back to the results ("Change
// Fare Class"), read and cleared once by the results page: that entry is a
// return to a search the traveller has already seen, so it must not be covered
// by the blocking "Searching the best deals" modal even when the results have
// to be fetched again.
export const FLIGHT_SKIP_SEARCH_MODAL_KEY = "flightSkipSearchModal";
// Set by redirectToFlightResults, the one way into a results page that means
// "run this search" - the home page, edit search, a booking that fell back to a
// fresh search. Read and cleared once by the results page, which then keeps the
// "search result have expired" modal down for that visit: the traveller asked
// for these prices, so a stale entry under the same search key is nothing they
// need to be told about. Sitting on the page until the results age out still
// warns, through the countdown.
export const FLIGHT_NEW_SEARCH_KEY = "flightNewSearch";
// How long a search's results, fare pick and filters stay good for. Held apart
// per flight type so the two can be tuned independently - international fares
// move on a different rhythm from domestic ones - even while both sit at ten
// minutes. Read through getFlightSearchCacheDuration, never directly, so a
// change to one of them cannot be applied to half the places that matter.
export const FLIGHT_SEARCH_CACHE_DURATION_DOMESTIC = 10 * 60 * 1000;
export const FLIGHT_SEARCH_CACHE_DURATION_INTERNATIONAL = 10 * 60 * 1000;

export const getFlightSearchCacheDuration = (flightType) =>
  flightType === "i"
    ? FLIGHT_SEARCH_CACHE_DURATION_INTERNATIONAL
    : FLIGHT_SEARCH_CACHE_DURATION_DOMESTIC;

/**
 * For the one cache that cannot know its flight type - the flight query id map,
 * which is keyed by fare uuid. It only exists to avoid asking the API to create
 * a query that already exists, so outliving the results it belongs to is
 * harmless; expiring before them is not.
 */
export const FLIGHT_SEARCH_CACHE_MAX_DURATION = Math.max(
  FLIGHT_SEARCH_CACHE_DURATION_DOMESTIC,
  FLIGHT_SEARCH_CACHE_DURATION_INTERNATIONAL,
);

export const BUS_RESTRICTIONS_LIST = [
  "pyay",
  "aunglan",
  "kyaikto",
  "thaton",
  "hpa-an",
  "mawlamyine",
  "ye",
  "mudon",
  "thanbyuzayat",
  "pakokku",
  "magway",
  "minbu",
  "pwintbyu",
  "salin",
  "kyaukpadaung",
  "yenangyaung",
  "ywar mon",
  "natmauk",
  "kyar kan",
  "lay tine sin",
  "kanbya",
  "bagan--nyaung-u",
  "kamma",
  "dawei",
  "palauk",
  "palaw",
  "pala",
  "myeik",
  "tanintharyi",
  "tachileik",
];

export const SHOW_NRC_NOTICE_FROM_HOME = "show_nrc_notice_from_home";

export const REACT_APP_BE_FALLBACK_URL =
  process.env.REACT_APP_TRACK_RELEASE_STAGE === "development"
    ? "https://coffee-be.mmflights.com"
    : "https://v4-be.flymya.com";

export const CABIN_CLASSES = [
  { label: "All Cabin Classes", value: "All Cabin Classes" },
  { label: "Economy", value: "Economy" },
  { label: "Premium Economy", value: "Premium Economy" },
  { label: "Business Class", value: "Business Class" },
  { label: "First Class", value: "First Class" },
];
export const CABIN_CLASS_FILTER = "cabinClassFilter";
export const ALL_CABIN_CLASSES = "All Cabin Classes";
export const MODIFICATION_POLICIES = [
  { label: "Yes", value: "dateChangeAllowed" },
  { label: "No", value: "dateChangeNotAllowed" },
  { label: "All", value: "dateChangeAll" },
  { label: "Yes", value: "nameChangeAllowed" },
  { label: "No", value: "nameChangeNotAllowed" },
  { label: "All", value: "nameChangeAll" },
  { label: "Yes", value: "sectorChangeAllowed" },
  { label: "No", value: "sectorChangeNotAllowed" },
  { label: "All", value: "sectorChangeAll" },
];
export const REFUND_POLICIES = [
  {
    label: "Refundable",
    value: "fullyRefundAllowed",
    descripiton:
      "*Full amount refunded to original payment method (fees may apply)",
  },
  {
    label: "Non Refundable",
    value: "noRefundAllowed",
    descripiton: "No refund; only date/name changes allowed (fees may apply)",
  },
];
export const TRIP_COM_AFFILIATE_URL =
  "https://www.trip.com/?Allianceid=3807294&SID=21329262&trip_sub3=M633096";
